import { ACTIONS_SBERMARKET } from '../actions/sbermarket';

export const sbermarket = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_SBERMARKET.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_SBERMARKET.CHANGE_PRODUCT: {
      const { product } = action;

      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    case ACTIONS_SBERMARKET.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
